import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientQuestionnaireControllerApi } from "../../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../../utils/utils";
import { OptionData } from "../use-assessment-get";

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useGraphFilledAssessment = (
  patientId: string
): useBaseContent<OptionData> => {
  return useQuery({
    queryKey: ["graph-assessment-filled", patientId],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientQuestionnaireControllerApi(getConfigObject())
        .getPatientQuestionnaire(patientId, getXtenantId())
        .then((res) => res?.data),
  });
};
